import { useEffect } from "react";

const LogOut = () => {
  const logout = () => {
    localStorage.clear();
    window.localStorage.clear();
    window.location.href = "/portal";
  };

  useEffect(() => {
    logout();
  }, []);

  return null;
};

export default LogOut;
